import React, { useState } from 'react'
import { useEffect } from 'react';
import { Table } from 'rsuite'
import LoadingSpinner from '../../Shared/GenericComponents/LoadingSpinner';
import credentialService from '../../../services/Internal/Credential/credential.service';
import { sort_by } from '../../Shared/HelperFunctions';
import EntityInformationPage from '../Credential/Shared/EntityInformationPage';

function StaffRelationshipChangeLog() {
    const [relationshipAuditTrail, setRelationshipAuditTrail] = useState([]);
    const [relationshipAuditTrailHasLoaded, setRelationshipAuditTrailHasLoaded] = useState(false);
    const [entityId, setEntityId] = useState();

    const refreshChangeLog = () => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        setEntityId(params.entityId);
        credentialService.getStaffRelationshipChangeLogData(params.entityId).then((response) => {
            setRelationshipAuditTrail(response.data.sort(sort_by('dateCrte', true)));
        })
        setRelationshipAuditTrailHasLoaded(true);
    }

    useEffect(() => {
        refreshChangeLog();
    }, [])

    return (<>
        {relationshipAuditTrailHasLoaded ? <>
            <EntityInformationPage entityId={entityId} activeKey={"entityInfo"} />
            <hr />
            <br />
            <h3 style={{ textAlign: "center" }}>Staff Caused Relationship Audit Trail</h3>
            <Table wordWrap autoHeight bordered affixHeader data={relationshipAuditTrail}>
                <Table.Column minWidth={50} flexGrow={.25}>
                    <Table.HeaderCell>
                        <b>Date</b>
                    </Table.HeaderCell>
                    <Table.Cell>{rowData => (rowData.dateCrte ? new Date(rowData.dateCrte).toLocaleDateString() : '')}</Table.Cell>
                </Table.Column>
                <Table.Column minWidth={125} flexGrow={.75}>
                    <Table.HeaderCell>
                        <b>User</b>
                    </Table.HeaderCell>
                    <Table.Cell>{rowData => (rowData.userCrte)}</Table.Cell>
                </Table.Column>
                <Table.Column minWidth={75} flexGrow={1}>
                    <Table.HeaderCell>
                        <b>Supervising Professional</b>
                    </Table.HeaderCell>
                    <Table.Cell>{rowData => (`${rowData.supervisingProfessionalName}/${rowData.supervisingProfessionalCredential} `)}</Table.Cell>
                </Table.Column>
                <Table.Column minWidth={125} flexGrow={.50}>
                    <Table.HeaderCell>
                        <b>Status Change</b>
                    </Table.HeaderCell>
                    <Table.Cell>{rowData => (`${rowData.oldRelationshipStatus} -> ${rowData.newRelationshipStatus}`)}</Table.Cell>
                </Table.Column>
                <Table.Column minWidth={125} flexGrow={.5}>
                    <Table.HeaderCell>
                        <b>Firm Still Compliant</b>
                    </Table.HeaderCell>
                    <Table.Cell>{rowData => (`${rowData.firmCredential} ${rowData.isFirmStillCompliant ? "Yes" : "No"}`)}</Table.Cell>
                </Table.Column>
            </Table>
        </> : <LoadingSpinner />
        }
    </>);
}
export default StaffRelationshipChangeLog;